/** These enum values are supported by the main AI.SDK registry */
export enum DocumentIntelligenceModelId {
  GoogleGemini3Flash = 'google:gemini-3-flash-preview',
  GoogleGemini31FlashLite = 'google:gemini-3.1-flash-lite-preview',
  GoogleGemma431b = 'google:gemma-4-31b-it',
  OpenAIGpt54 = 'openai:gpt-5.4',
  OpenAIGpt54Mini = 'openai:gpt-5.4-mini',
  OpenAIGpt54Nano = 'openai:gpt-5.4-nano',
}
